import userStore from '@/stores/UserStore'

export function checkPermissions (requiredPermissions) {
	const userPermissions = userStore.state.companyPermissions
	if(!userPermissions) return false
	const hasPermission = requiredPermissions.every(permission =>
		userPermissions[permission] === true
	)
  return hasPermission
}